import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const FacebookPost = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12725"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12725)">
          <rect
            x="-23"
            y="-2"
            width="151"
            height="115"
            rx="4.87097"
            fill="#FEF2F2"
          />
          <path
            d="M60.9924 74.0015H35.4543L20.861 84.9465V74.0015H13.5643C11.6186 74.0015 9.91602 72.2991 9.91602 70.3531V33.87C9.91602 31.9242 11.6186 30.2217 13.5643 30.2217H60.9924C62.9384 30.2217 64.6408 31.9242 64.6408 33.87V70.3531C64.6408 72.2991 62.9384 74.0015 60.9924 74.0015Z"
            fill="white"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="15.3586"
            y="52.7131"
            width="46.8831"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="15.3586"
            y="57.584"
            width="37.1411"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="15.3586"
            y="62.4551"
            width="26.1815"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <circle
            cx="17.7941"
            cy="38.7092"
            r="2.43548"
            fill="#1E1E1E"
          />
          <rect
            x="22.665"
            y="37.4915"
            width="23.1371"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="48.2378"
            y="37.4915"
            width="12.1774"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <path
            d="M48.4525 80.8622H67.0037L77.6046 88.8127V80.8622H82.905C84.3184 80.8622 85.5552 79.6255 85.5552 78.2119V51.71C85.5552 50.2966 84.3184 49.0598 82.905 49.0598H48.4525C47.0389 49.0598 45.8022 50.2966 45.8022 51.71V78.2119C45.8022 79.6255 47.0389 80.8622 48.4525 80.8622Z"
            fill="white"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M63.9772 72.7728C64.6671 73.5191 65.8429 73.5308 66.5476 72.7985L74.2594 64.7841C75.8495 63.194 76.2029 60.7205 75.3195 58.6003C73.7294 55.4201 69.3124 54.7134 66.8389 57.1869L65.4255 58.6003L64.0119 57.1869C61.3618 54.5367 57.1215 55.2434 55.5313 58.6003C54.4714 60.7205 54.8247 63.194 56.5915 64.7841L63.9772 72.7728Z"
            fill="#FF5A4F"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M64.6773 46.0158H9.87891V44.7981H64.6773V46.0158Z"
            fill="black"
          />
          <rect
            x="73.0492"
            y="21.5453"
            width="31.9657"
            height="31.9657"
            rx="15.9829"
            fill="white"
          />
          <rect
            x="73.0492"
            y="21.5453"
            width="31.9657"
            height="31.9657"
            rx="15.9829"
            stroke="#1E1E1E"
            strokeWidth="0.913306"
          />
          <path
            d="M98.167 37.5839C98.167 42.1714 94.8263 45.9738 90.4593 46.6631V40.2406H92.5878L92.9929 37.5839H90.4593V35.8599C90.4593 35.1329 90.8133 34.4245 91.948 34.4245H93.0999V32.1627C93.0999 32.1627 92.0544 31.9832 91.0549 31.9832C88.9685 31.9832 87.6046 33.2556 87.6046 35.559V37.5839H85.2852V40.2406H87.6046V46.6631C83.2377 45.9738 79.897 42.1714 79.897 37.5839C79.897 32.5081 83.987 28.3931 89.032 28.3931C94.0769 28.3931 98.167 32.5081 98.167 37.5839Z"
            fill="white"
          />
          <path
            d="M91.9789 38.3417L92.3839 35.7012H89.8504V33.9876C89.8504 33.2652 90.2043 32.561 91.3391 32.561H92.491V30.3129C92.491 30.3129 91.4456 30.1345 90.4461 30.1345C88.3595 30.1345 86.9957 31.3991 86.9957 33.6886V35.7012H84.6763V38.3417H86.9957V44.7251C87.4608 44.7981 87.9375 44.8362 88.423 44.8362C88.9086 44.8362 89.3853 44.7981 89.8504 44.7251V38.3417H91.9789Z"
            fill="#1877F2"
          />
        </g>
      </SvgIcon>
    );
  })
);
FacebookPost.displayName = 'FacebookPost';
